import { getMicroserviceBaseContext } from "../../../../constants/api-routing";
;
const conversationsContext = getMicroserviceBaseContext('conversations');

const categories_url = `${conversationsContext}categories/`;
export const REQUEST_CATEGORIZATION = {
  GET_CATEGORIES_BY_BU: `${categories_url}get_categories_by_bu`,
  UPSERT_CATEGORY: `${categories_url}upsert_category`,
  GET_VERSION_HISTORY: `${categories_url}get_version_history`,
  GET_SECONDARY_CATEGORY_HISTORY: `${categories_url}get_secondary_category_history`,
  GET_CATEGORIZATION_SCHEDULER_HISTORY: `${categories_url}get_categorization_schedulers`,
  ADD_SCHEDULER_FOR_CATEGORIZATION: `${categories_url}add_scheduler_for_categorization`,
  CATEGORIZATION_SCHEDULER_ACTION: `${categories_url}categorization_scheduler_action`
};
